import { movies } from "@/mocks/movies";
import { actors } from "@/mocks/actors";

export function getMovieById(id) {
  return movies.find((m) => String(m.id) === String(id)) || null;
}

export function getActorById(id) {
  return actors.find((a) => a.id === id) || null;
}

export function getActorsByMovie(movie) {
  if (!movie) return [];
  return (movie.cast || [])
    .map((id) => getActorById(id))
    .filter(Boolean);
}

export function getFeaturedMovies() {
  const featured = movies.filter((m) => m.featured);
  return featured.length ? featured : movies.slice(0, 4);
}

export function getLatestMovies(limit) {
  const sorted = [...movies].sort(
    (a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()
  );
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function getHotMovies(limit) {
  const sorted = [...movies].sort((a, b) => b.heat - a.heat);
  return typeof limit === "number" ? sorted.slice(0, limit) : sorted;
}

export function filterMovies(options = {}) {
  const { types = [], regions = [], years = [], tags = [], sort = "latest" } = options;
  let list = movies.filter((m) => {
    if (types.length && !types.includes(m.type)) return false;
    if (regions.length && !regions.includes(m.region)) return false;
    if (years.length && !years.includes(String(m.year))) return false;
    if (tags.length && !tags.some((t) => (m.tags || []).includes(t) || (m.genres || []).includes(t))) return false;
    return true;
  });

  if (sort === "heat") list = list.sort((a, b) => b.heat - a.heat);
  else if (sort === "rating") list = list.sort((a, b) => b.rating - a.rating);
  else list = list.sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime());

  return list;
}

export function searchMovies(keyword) {
  const kw = (keyword || "").trim().toLowerCase();
  if (!kw) return [];
  return movies.filter((m) => {
    const actorNames = getActorsByMovie(m).map((a) => a.name).join(" ");
    const haystack = [
      m.title,
      m.type,
      m.region,
      m.director,
      String(m.year),
      (m.genres || []).join(" "),
      (m.tags || []).join(" "),
      m.summary,
      actorNames,
    ]
      .join(" ")
      .toLowerCase();
    return haystack.includes(kw);
  });
}

export function getRelatedMovies(movie, limit = 4) {
  if (!movie) return getHotMovies(limit);
  const scored = movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      let score = 0;
      if (m.type === movie.type) score += 2;
      if (m.region === movie.region) score += 1;
      const sharedGenre = (m.genres || []).filter((g) => (movie.genres || []).includes(g)).length;
      score += sharedGenre * 2;
      const sharedCast = (m.cast || []).filter((c) => (movie.cast || []).includes(c)).length;
      score += sharedCast * 3;
      const sharedTag = (m.tags || []).filter((t) => (movie.tags || []).includes(t)).length;
      score += sharedTag;
      return { m, score };
    })
    .filter((item) => item.score > 0)
    .sort((a, b) => b.score - a.score);
  const result = scored.map((item) => item.m);
  if (result.length < limit) {
    const extra = getHotMovies(20).filter(
      (m) => m.id !== movie.id && !result.some((r) => r.id === m.id)
    );
    return [...result, ...extra].slice(0, limit);
  }
  return result.slice(0, limit);
}

export function getMoviesByIds(ids) {
  return (ids || []).map((id) => getMovieById(id)).filter(Boolean);
}

export function formatReleaseDate(dateStr) {
  if (!dateStr) return "";
  const parts = String(dateStr).split("-");
  if (parts.length < 3) return dateStr;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}

export function getTypeMeta(type) {
  const map = {
    电影: "ri-film-line",
    电视剧: "ri-tv-2-line",
    网剧: "ri-smartphone-line",
    纪录片: "ri-camera-lens-line",
    综艺: "ri-mic-line",
    动漫: "ri-magic-line",
  };
  return map[type] || "ri-movie-line";
}